document.addEventListener('DOMContentLoaded', () => {
  const section = document.querySelector('.impact-section');
  const asterisks = section.querySelectorAll('.asterisk');
  let tooltipTimeouts = [];
  
  // Use requestAnimationFrame for performance
  function animateIn() {
    requestAnimationFrame(() => {
      section.classList.add('is-visible');
    });
  }
  
  // Setup click handling for asterisks
  asterisks.forEach(asterisk => {
    asterisk.addEventListener('click', (e) => {
      e.stopPropagation();
      
      // Remove active class from all other asterisks
      asterisks.forEach(a => {
        if (a !== asterisk) a.classList.remove('active');
      });
      
      // Toggle active state for this asterisk
      asterisk.classList.toggle('active');
    });
  });
  
  // Close tooltips when clicking outside
  document.addEventListener('click', () => {
    asterisks.forEach(asterisk => {
      asterisk.classList.remove('active');
    });
  });

  // Debounced resize function for performance
  let resizeTimer;
  const handleResize = () => {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(() => {
      // Close any open tooltips on resize
      asterisks.forEach(asterisk => {
        asterisk.classList.remove('active');
      });
      section.classList.remove('tooltip-show');
    }, 250);
  };
  
  window.addEventListener('resize', handleResize);

  // Intersection Observer for section visibility
  const observer = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        animateIn();
        
        // Schedule automatic tooltip display
        if (window.innerWidth > 768) { // Only show auto tooltips on larger screens
          scheduleTooltips();
        }
      } else {
        // Remove visible class when out of view
        section.classList.remove('is-visible');
        
        // Clear any scheduled tooltips
        tooltipTimeouts.forEach(timeout => clearTimeout(timeout));
        tooltipTimeouts = [];
        
        // Remove any active tooltips
        asterisks.forEach(asterisk => {
          asterisk.classList.remove('active');
        });
        
        section.classList.remove('tooltip-show');
      }
    });
  }, {
    threshold: 0.25,
    rootMargin: '-5% 0px'
  });

  observer.observe(section);
  
  // Function to schedule automatic tooltip shows with better performance
  function scheduleTooltips() {
    // Clear existing timeouts
    tooltipTimeouts.forEach(timeout => clearTimeout(timeout));
    tooltipTimeouts = [];
    
    // Initial delay before starting tooltip animations
    const initialDelay = 3000;
    
    // Create a sequence of tooltip shows
    function createTooltipSequence() {
      // Show first tooltip
      const timeout1 = setTimeout(() => {
        requestAnimationFrame(() => {
          section.classList.add('tooltip-show');
          asterisks[0].classList.add('active');
        
        });
        
        // Hide after 3 seconds
        const hideTimeout1 = setTimeout(() => {
          requestAnimationFrame(() => {
            section.classList.remove('tooltip-show');
            asterisks[0].classList.remove('active');
          });
          
         
          
          
        }, 3000);
        
        tooltipTimeouts.push(hideTimeout1);
      }, initialDelay);
      
      tooltipTimeouts.push(timeout1);
    }
    
    // Start the sequence
    createTooltipSequence();
  }

  // Pause animations when page is not visible to save resources
  document.addEventListener('visibilitychange', () => {
    if (document.visibilityState === 'hidden') {
      tooltipTimeouts.forEach(timeout => clearTimeout(timeout));
      tooltipTimeouts = [];
    } else if (document.visibilityState === 'visible' && section.classList.contains('is-visible')) {
      scheduleTooltips();
    }
  });
});